(() => {
  function repairBrandMegaMenu() {
    const grid = document.querySelector('[data-pq-mega="brands"] .wstq-mega__grid--brands');
    if (!grid) return;
    const links = grid.querySelectorAll('a');
    if (links.length > 1) return;
    const brands = [
      ['Pattana', '/collections/pattana'],
      ['Marco Fu', '/collections/marco-fu'],
      ['Taom', '/collections/taom'],
      ['ZAN', '/collections/zan'],
      ['Triple Crown', '/collections/triple-crown'],
      ['Lion Carbon Fiber', '/collections/lion'],
      [window.ProjectQI18n.tong_yi, '/collections/tong-yi']
    ];
    grid.replaceChildren(...brands.map(([name, href]) => {
      const a = document.createElement('a');
      a.href = window.ProjectQLocalizedUrl(href);
      a.textContent = name;
      return a;
    }));
  }

  function removeUnpublishedLinks() {
    document.querySelectorAll('a[href="/pages/returns"], a[href$="/pages/returns"]').forEach((link) => link.remove());
  }

  function refreshCartBadge() {
    const badge = document.querySelector('.wstq-cart-count');
    if (!badge) return;
    fetch(window.ProjectQRoutes.root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((r) => r.ok ? r.json() : null)
      .then((cart) => {
        if (!cart || typeof cart.item_count !== 'number') return;
        badge.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count);
        badge.hidden = cart.item_count === 0;
        const cartLink = document.querySelector('.wstq-cart-link');
        if (cartLink) cartLink.setAttribute('aria-label', window.ProjectQI18n.cart_count.replace('__COUNT__', String(cart.item_count)));
      })
      .catch(() => {});
  }

  function init() {
    repairBrandMegaMenu();
    removeUnpublishedLinks();
    refreshCartBadge();
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('pageshow', refreshCartBadge);
  document.addEventListener('cart:updated', refreshCartBadge);
  document.addEventListener('cart:refresh', refreshCartBadge);
})();

(() => {
  const applyV4Copy = () => {
    const heroPrimary = document.querySelector('.pqv2-hero__primary');
    if (heroPrimary) {
      heroPrimary.textContent = window.ProjectQI18n.shop_new_cues;
      heroPrimary.href = window.ProjectQRoutes.new_cues;
    }

    const brandsLink = document.querySelector('.pqv2-brands__head a');
    if (brandsLink) brandsLink.textContent = window.ProjectQI18n.all_brands;

    const categoryCue = document.querySelector('.pqv2-category:first-child img');
    const featuredCue = document.querySelector('.pqv2-card__image');
    if (categoryCue && featuredCue) {
      categoryCue.src = featuredCue.src;
      categoryCue.srcset = featuredCue.srcset;
      categoryCue.sizes = '(max-width: 749px) 100vw, 58vw';
      categoryCue.alt = window.ProjectQI18n.featured_cues;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyV4Copy, { once: true });
  } else {
    applyV4Copy();
  }
})();

(() => {
  const ready = (fn) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  };

  ready(() => {
    document.addEventListener("click", (event) => {
      const summary = event.target.closest(".wstq-mega > summary");
      if (!summary) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const details = summary.closest("details");
      const nextOpen = !details.open;
      document.querySelectorAll(".wstq-mega[open]").forEach((item) => {
        if (item !== details) item.open = false;
      });
      details.open = nextOpen;
      window.setTimeout(() => {
        details.open = nextOpen;
      }, 0);
    }, true);

    document.addEventListener("click", (event) => {
      if (!event.target.closest(".wstq-mega")) {
        document.querySelectorAll(".wstq-mega[open]").forEach((item) => {
          item.open = false;
        });
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      document.querySelectorAll(".wstq-mega[open], .wstq-mobile-menu[open]").forEach((item) => {
        item.open = false;
      });
    });

    const mobileMenu = document.querySelector(".wstq-mobile-menu");
    if (mobileMenu) {
      mobileMenu.addEventListener("toggle", () => {
        const summary = mobileMenu.querySelector(":scope > summary");
        if (summary) {
          summary.setAttribute("aria-expanded", mobileMenu.open ? "true" : "false");
          summary.setAttribute("aria-label", mobileMenu.open ? window.ProjectQI18n.close_menu : window.ProjectQI18n.open_menu);
        }
      });
    }

    const emptyCart = document.querySelector(".pq-empty--large");
    if (emptyCart && !emptyCart.querySelector(".pq-empty__quick-links")) {
      const links = document.createElement("nav");
      links.className = "pq-empty__quick-links";
      links.setAttribute("aria-label", window.ProjectQI18n.popular_categories);
      [
        [window.ProjectQI18n.new_cues, "/collections/%E5%85%A8%E6%96%B0%E7%90%83%E6%A1%BF"],
        [window.ProjectQI18n.cue_tips, "/collections/cue-tips"],
        [document.documentElement.dataset.pqChalkLabel, "/collections/chalk"]
      ].forEach(([label, href]) => {
        const anchor = document.createElement("a");
        anchor.href = window.ProjectQLocalizedUrl(href);
        anchor.textContent = label;
        links.appendChild(anchor);
      });
      emptyCart.appendChild(links);
    }
  });
})();


